import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import { useChecklistEditAction, useChecklistSimulationAction } from './actions'

export const useChecklistFastActionsList = (item, opts = {}) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const simulation = useChecklistSimulationAction(item)
  const edit = useChecklistEditAction(item)

  return [
    ...appendIf(!hide.includes('simulation'), {
      value: t('simulation'),
      icon: 'BsCollectionPlay',
      onClick: simulation.click
    }),

    ...appendIf(edit.hasPermission, {
      value: t('edit'),
      icon: 'BsPencil',
      onClick: edit.click,
      to: edit.link
    })
  ]
}
